<div class="dialog-success-error">
  @if(data.title) {
    <header class="dialog-success-error__header">
      <ci-icon 
        class="dialog-success-error__icon"
        type="svg" 
        [name]="data.iconName"
        scale="1.5x"
      ></ci-icon>
        
      <h2 class="dialog-success-error__title ci-subheading-semibold">
        {{ data.title | translate }}
      </h2>
    </header>
  }
    
  @if (data.content) {
    <main class="dialog-success-error__main">
      @if (isSuccessList()) {          
        <ci-accordion 
          #successAccordion
          [open]="successAccordionOpen()"
          text-button
          (accordion-toggle)="toggleAccordion('success')"
        >
          <span 
            slot="label"
            class=" ci-paragraph-p1-semibold"
          >
            <ci-icon 
              class="dialog-success-error__success-icon"
              type="svg" 
              name="btn-check" 
              scale="1x"
            ></ci-icon>
            
            <span class="dialog-success-error__label-text">
              {{ ('Ha sido posible modificar' | translate) + ' ' + data.content.successList.length + ' ' + ('recursos' | translate) }} 
            </span>
          </span>
          
          <section 
            #successSection
            class="dialog-success-error__success"
          >
            <ul class="dialog-success-error__success-list"> 
              @for (success of data.content.successList; track success.id) {
                <li class="ci-paragraph-p1-regular dialog-success-error__success-item">
                  {{ success.title }}
                </li>
              }
            </ul>
          </section>
        </ci-accordion>
      }
      
      @if (isErrorList()) {
        <ci-accordion 
          #errorAccordion
          [open]="errorAccordionOpen()"
          text-button
          (accordion-toggle)="toggleAccordion('error')"
        >
          <span 
            slot="label"
            class="ci-paragraph-p1-semibold"
          >
            <ci-icon 
              class="dialog-success-error__error-icon"
              type="svg"
              name="close" 
              scale="1x"
            ></ci-icon>
            
            <span class="dialog-success-error__label-text">
              {{ ('No ha sido posible modificar' | translate) + ' ' + data.content.errorList.length + ' ' + ('recursos' | translate) }}  
            </span>
          </span>
          
          <section 
            #errorSection
            class="dialog-success-error__error"
          >
            <ul class="dialog-success-error__error-list"> 
              @for (error of data.content.errorList; track error.id) {
                <li class="ci-paragraph-p1-regular dialog-success-error__error-item">
                  {{ error.title }}
                </li>
              }
            </ul>
          </section>
        </ci-accordion>
      }
    </main>
  }
  
  @if (data.handleClickPrimaryButton) {
    <footer class="dialog-success-error__footer">
        <ci-text-button
          class="dialog-success-error__primary-button"
          class-name="ci-text-btn-primary-s"
          type="button"
          [attr.aria-label]="data.primaryActionButtonText | translate"
          (click)="data.handleClickPrimaryButton()"
        >
          {{ data.primaryActionButtonText| translate }}
        </ci-text-button>
    </footer>
  }
</div>